export default __webpack_public_path__ + "static/media/developmental-stage.3bd3e623.svg";